import React from 'react';
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import {Form} from 'semantic-ui-react';
import PropTypes from 'prop-types';

class TaxRateSelector extends React.PureComponent {
    //access router
    //this.props.history.push('/dashboard')    
    render() {
        const {taxes, label, selected, onSelectChange} = this.props;
        const options = [];
        _.each(taxes, c => {
            options.push({
                value: _.toString(c.rate),
                text: c.name,
                key: c.id
            });
        });
        options.unshift({
            value: "0",
            text: "N/A",
            key: -1
        });
        return (
            <Form.Select fluid search selection 
                label={label}
                options={options}
                name="term_id" value={selected ? _.toString(selected) : "0"} 
                onChange={(e, {value}) => {
                    onSelectChange(value)
                }}
            />
        )
    }
}

TaxRateSelector.propTypes = {
    onSelectChange: PropTypes.func.isRequired,
    taxes: PropTypes.array.isRequired,
    label: PropTypes.string
    //history: PropTypes.shape({
    //    push: PropTypes.func.isRequired
    //}).isRequired,
};

function mapStateToProps(state) {
    return {
        taxes: state.system.resources.taxes
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxRateSelector)